import React from "react";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useField} from "formik";



export default function CallToActionCheckBox(props) {
  const [field, meta, helpers] = useField(props.name);

  const handleChange = (event) => {
    helpers.setValue(event.target.value);
  };

  return (
    <>
      <FormControl  {...field} error={meta.touched && meta.error} component="fieldset" >
        <FormLabel component="legend">Call to action</FormLabel>
        <RadioGroup  name={props.name} value={field.value} onChange={handleChange}>
        <FormControlLabel value="Shop now" control={<Radio color="primary" />} label="Shop now" />
        <FormControlLabel value="Learn more" control={<Radio color="primary" />} label="Learn more" />
        </RadioGroup>
       
            <FormHelperText error >{meta.error}</FormHelperText>

      </FormControl>
    </>
  );
}
